/**
 * 機能フラグ一覧
 * 目的: 一時的な公開/非公開などを環境変数で素早く切り替えられるようにする
 */

/**
 * サービスページ（/services, /services/[id]）を公開するか
 * 目的: 一旦非表示にしたサービス導線を、コード改修なしで復帰できるようにする
 * 環境変数:
 * - NEXT_PUBLIC_SERVICES_PUBLIC=1 のとき公開
 * 戻り値: boolean（true=公開）
 */
export function isServicesPublic(): boolean {
  return process.env.NEXT_PUBLIC_SERVICES_PUBLIC === '1';
}


